import React from 'react'
import { PaymentsModule } from '@bcraft-frontend-lib/payments'

import { PaymentsRedirect } from './pages'

export class PaymentsPageModule {
  getRoutes() {
    return <PaymentsModule serviceRedirect={<PaymentsRedirect />} />
  }
}
